import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Preloader = ({ onDone }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      onDone?.();
    }, 1900);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#1a130b]"
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: EASE }}
        >
          <div className="overflow-hidden">
            <motion.h1
              className="font-serif text-[#f2ece0] text-6xl md:text-8xl tracking-tight"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
            >
              KHADI<span className="text-[#a65a34]">.</span>
            </motion.h1>
          </div>
          <motion.div
            className="absolute bottom-10 left-1/2 -translate-x-1/2 font-display text-[10px] tracking-[0.4em] uppercase text-[#f2ece0]/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            Fashion Icon India
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
